import { render, staticRenderFns } from "./AppDbListModal.vue?vue&type=template&id=0bb819be"
import script from "./AppDbListModal.vue?vue&type=script&lang=js"
export * from "./AppDbListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports